import Vue from "vue";
import Router from "vue-router";
Vue.use(Router)
export const asyncRoutes = [
  // {
  //   path: "/",
  //   redirect: "/login"
  // },
  
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/Home/index'),
    meta: { title: '入学报名', icon: 'dashboard',keepAlive: true },
  },
  {
    path: "/login",
    component: () => import('@/pages/Login/index'),
    meta: { title: '登录', icon: 'dashboard'},
  },
  {
    path: '/personCenter', 
    name: 'personCenter',
    component: () => import('@/pages/personCenter/index'),
    meta: { title: '个人中心', icon: 'dashboard' }
  },
  {
    path: '/registrateProgress',
    name: 'registrateProgress',
    component: () => import('@/pages/personCenter/registrateProgress'),
    meta: { title: '报名进展', icon: 'dashboard'}
  },
  {
    path: '/myAcademic',
    name: 'myAcademic',
    component: () => import('@/pages/personCenter/myAcademic'),
    meta: { title: '我的学籍', icon: 'dashboard'}
  },
  {
    path: '/myCourse',
    name: 'myCourse',
    component: () => import('@/pages/personCenter/myCourse'),
    meta: { title: '我的课程', icon: 'dashboard'}
  },
  {
    path: '/myCouseAchievement',
    name: 'myCouseAchievement',
    component: () => import('@/pages/personCenter/myCouseAchievement'),
    meta: { title: '我的成绩', icon: 'dashboard'}
  },
  {
    path: '/idCard',
    name: 'idCard',
    component: () => import('@/pages/Home/IDCard'),
    meta: { title: '制作个人证件照片', icon: 'dashboard' }
  },
  {
    path: '/uploadTemp',
    name: 'uploadTemp',
    component: () => import('@/pages/Home/UploadTemp'),
    meta: { title: '制作个人证件照片', icon: 'dashboard' }
  },
  {
    path: '/diploma',
    name: 'diploma',
    component: () => import('@/pages/Home/diploma'),
    meta: { title: '学历毕业证书', icon: 'dashboard' }
  },
  {
    path: '/work',
    name: 'work',
    component: () => import('@/pages/Home/work'),
    meta: { title: '工作证明', icon: 'dashboard' }
  },
  {
    path: '/Sign',
    name: 'Sign',
    component: () => import('@/pages/Sign/Sign'),
    meta: { title: '入学承诺签名', icon: 'dashboard' }
  },
  {
    path: '/accept',
    name: 'accept',
    component: () => import('@/pages/Sign/Accept/Accept'),
    meta: { title: '入学承诺书', icon: 'dashboard' }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/pages/Home/success'),
    meta: { title: '报名成功', icon: 'dashboard' }
  },
  {
    path: '/schoolProfile',
    name: 'schoolProfile',
    component: () => import('@/pages/ReadInfo/schoolProfile'),
    meta: { title: '学校简历', icon: 'dashboard' }
  },
  {
    path: '/schoolDetails',
    name: 'schoolDetails',
    component: () => import('@/pages/ReadInfo/schoolDetails'),
    meta: { title: '学校简历', icon: 'dashboard' }
  },
  {
    path: '/educateInstitute',
    name: 'educateInstitute',
    component: () => import('@/pages/ReadInfo/educateInstitute'),
    meta: { title: '办学单位', icon: 'dashboard' }
  },
  {
    path: '/enrollmentMajor',
    name: 'enrollmentMajor',
    component: () => import('@/pages/ReadInfo/enrollmentMajor'),
    meta: { title: '招生专业', icon: 'dashboard' }
  },
  {
    path: '/studentBrochure',
    name: 'studentBrochure',
    component: () => import('@/pages/ReadInfo/studentBrochure'),
    meta: { title: '招生简章', icon: 'dashboard' }
  }
]
const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      x: 0,
      y: 0,
    }),
    routes: [...asyncRoutes],
  })

const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

